export const stepsContainer = {
  display: 'flex',
  gap: '1.5px',

  '[role="progressbar"]': {
    width: '100%',
  },
}
